import * as React from "react";
import PropTypes from "prop-types";
import HttpClient, { HttpClientConfig } from "../../../utils/HttpClient";
import FormikAutocompleteMultiple from "../../formik/FormikAutocompleteMultiple";
import { useEffect } from "react";

export const LabelAutocompleteMultiple = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/Label/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/Label/LookupById`;
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [options, setOptions] = React.useState([]);

  useEffect(() => {
    HttpClient.HttpClientWebApi().get(lookupUrl).then(r => {
      setOptions(r.data);
      handleOnGetSelectedValues(r.data);
    });

  }, []);

  const handleAddClick = (e) => {
    console.log(e);
  }

  const handleChange = (e, a) => {
    const d = a?.map(a => ({ organizationId: a.data.organizationId, labelId:  a.id}) ); // change this to adapt the current model
    props.formik.setFieldValue(props.fieldName, d);
    setSelectedOptions(a);
  };

  const handleOnGetSelectedValues = (e) => {
    // This method must return an object of this shape: { title: string, id: number, data: any };
    const a = props?.formik?.values?.organizationLabels?.map(o => { return { title: o.label.name, id: o.label.id, data: o }}); // change this to adapt the current model
    setSelectedOptions(a);
  }

  return (
    <FormikAutocompleteMultiple
      {...props}
      onAddButtonClick={handleAddClick}
      options={options}
      selectedOptions={selectedOptions}
      onChange={handleChange}
    />
  );
};

LabelAutocompleteMultiple.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default LabelAutocompleteMultiple;
